//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        plate: {
            type: Object
        },
        building_id:{
            type: [Number, String]
        }
    },
    methods: {
        openDetail () {
            this.$sendCtmEvtLog(`楼盘详情-板块入口点击`, {building_id: this.building_id})
            wx.navigateTo({
                url: `/packageB/plates/main?id=${this.plate.id}`
            })
        }
    }
}
